import {Component, OnInit} from '@angular/core';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {InventarioServices} from '../services/inventario.services';
import {NgxSpinnerService} from 'ngx-spinner';
import * as moment from 'moment';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TypeaheadMatch} from 'ngx-bootstrap';

@Component({
  selector: 'reporte-inventario-categoria',
  templateUrl: '../templates/reporte.inventario.categoria.template.html'
})
export class ReporteInventarioCategoriaComponent implements OnInit {

  public tiendas: TiendaEntity[] = [];
  public tiendaSelect: TiendaEntity;
  public tSelectName: string = '';
  public tituloReport: string = '';

  public fechaMesAnterior:string = '';

  public resultCat: any[] = [];

  graphDiasInv:any[] = [];
  graphCantidad:any[] = [];
  totalDiasInvTienda = 0;

  constructor(private ts: TiendaServices, private is: InventarioServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {

    this.spinner.show();

    this.ts.getAllTiendas().subscribe(d => {
      console.log(d);
      this.tiendas = d.data.tiendas;
      this.spinner.hide();
      this.tiendaSelect = this.tiendas[0];
      this.tSelectName = this.tiendaSelect.nombre;
    });

    this.is.obsSendInvXCat.subscribe(d => {

      this.spinner.hide();
      let jData = JSON.parse(d);


      let ventas = jData.ventas;
      let inventario = jData.inventario;

      for (let i of inventario) {
        let iFound = this.resultCat.find(rc => rc.nombre == i.categoria.trim());

        if (iFound) {
          iFound.cantidad += i.cantidad;

          let mFound = iFound.marcas.find(m => m.nombre == i.marca.trim());

          if (mFound) {
            mFound.cantidad += i.cantidad;
          } else {
            let marca = {
              nombre: i.marca.trim(),
              ventasMesAnt:0,
              cantidad: i.cantidad
            };

            iFound.marcas.push(marca);
          }
        } else {
          let cat = {
            nombre: i.categoria.trim(),
            cantidad: i.cantidad,
            ventasMesAnt:0,
            marcas: []
          };

          let marca = {
            nombre: i.marca.trim(),
            ventasMesAnt:0,
            cantidad: i.cantidad
          };

          cat.marcas.push(marca);
          this.resultCat.push(cat);
        }
      }

      for(let v of ventas){
        for(let a of v.articulos){
          let iFound = this.resultCat.find(rc => rc.nombre == a.categoria.trim());

          if(iFound){
            iFound.ventasMesAnt++;

            let mFound = iFound.marcas.find(m => m.nombre == a.marca.trim());

            if(mFound)
              mFound.ventasMesAnt++;
            else{
              let marca = {
                nombre: a.marca.trim(),
                ventasMesAnt:1,
                cantidad: 0
              };

              iFound.marcas.push(marca);
            }

          }
          else{
            let cat = {
              nombre: a.categoria.trim(),
              cantidad: 0,
              ventasMesAnt:1,
              marcas: []
            };

            let marca = {
              nombre: a.marca.trim(),
              ventasMesAnt:1,
              cantidad: a.cantidad
            };

            cat.marcas.push(marca);
            this.resultCat.push(cat)
          }
        }
      }
      console.log(this.resultCat);



      this.organizarCategoriasYMarcas();
      for (let c of this.resultCat){
        this.graphDiasInv.push({
          name:c.nombre,
          value:c.diasInv
        });

        this.totalDiasInvTienda += c.diasInv;

        this.graphCantidad.push(({
          name:c.nombre,
          value: c.cantidad
        }));
      }

    });

  }

  organizarCategoriasYMarcas()
  {
    for(let c of this.resultCat){
      if(c.ventasMesAnt > 0)
        c.diasInv = (c.cantidad / c.ventasMesAnt) * 30;
      else
        c.diasInv = 0;

      for(let m of c.marcas){
        if(m.ventasMesAnt > 0)
          m.diasInv = (m.cantidad / m.ventasMesAnt) * 30;
        else
          m.diasInv = 0;
      }

      c.marcas.sort((a,b)=>{
        if (a.diasInv > b.diasInv)
          return -1;
        else
          return 1;
      });
      c.marcas = c.marcas.slice(0, 5);

    }
  }
  tiendaSeleccionada(event: TypeaheadMatch) {
    this.tiendaSelect = event.item;
  }

  consultarDatos() {
    if (this.tiendaSelect) {
      let fecha = moment();
      this.resultCat = [];
      this.graphCantidad = [];
      this.graphDiasInv = [];
      this.totalDiasInvTienda = 0;
      this.tituloReport = `Reporte Inventarios X Categoria del ${moment().format('DD-MM-YYYY')}`;
      this.fechaMesAnterior = `(${moment().subtract(1,'month').format('DD-MM-YYYY')} al ${moment().format('DD-MM-YYYY')})`;
      console.log(`consultando tienda ${this.tiendaSelect.id.toString()}`);
      this.spinner.show();
      this.is.getInvXCat(4, this.tiendaSelect.id.toString(), fecha.format('YYYY-MM-DD'));

    }
  }
}
